<template>
    <div class="page" :class="{'surface fill-height': phoneOnly}">
        <v-container :class="{'px-0': phoneOnly}">
            <div v-if="isTeacher" class="px-4 px-md-0 mb-6 d-flex justify-space-between">
                <enrollments-select v-model="enrollment_id" style="max-width: 350px" />
                <div></div>
            </div>
            <v-list v-if="reports && reports.length" class="px-4 pa-md-0 ma-0 transparent">
                <template v-for="(report, i) in reports" >
                    <v-list-item :key="report.id" v-ripple="phoneOnly ? {class: 'ripple--color'} : false" @click="expand(report)" class="bordered rounded px-5 py-2 mb-3">
                        <v-list-item-icon tile class="me-md-6 align-self-start mt-4" size="45">
                            <v-icon size="36" color="primary">mdi-file-account-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{isTeacher ? (report.student ? report.student.name + ' - ' : '') : ''}}
                                {{report.class ? (report.class.is_program_class ? (report.class.program ? report.class.program.name : 'Program Class') : (report.class.enrollment && report.class.enrollment.course ? report.class.enrollment.course.name : '')) : ''}}
                            </v-list-item-title>
                            <v-list-item-subtitle class="details-text">
                                <div class="d-flex align-center">
                                    <div class="details-text primary--text font-weight-bold">{{ report.evaluation }}</div>
                                    <div class="ms-3 d-flex font-weight-bold">
                                        <v-icon size="16" class="me-1">mdi-calendar</v-icon>
                                        <span>{{dateTimeFormat(report.created_at_timestamp, true).split(' ')[0]}} <!-- <span class="muted--text">({{report.created_at_readable}})</span> --></span>
                                    </div>
                                    <!-- <div class="ms-3 d-flex">
                                        <v-icon size="16" class="me-1">mdi-clock-outline</v-icon>
                                        <span>{{dateTimeFormat(report.created_at_timestamp, true).split(' ')[1]}}</span>
                                    </div> -->
                                </div>
                            </v-list-item-subtitle>
                            <v-expand-transition>
                                <div v-if="expandReport && expandedReport.id === report.id" class="details-text ">
                                    <v-divider class="my-3"></v-divider>
                                    <div class="mb-3">
                                        <h3 class="strong-text--text font-weight-semibold mb-1">Lesson Summary</h3>
                                        <p class="text--text" style="white-space: pre-line;" v-html="urlify(escapeHtmlText(expandedReport.lesson_summary))"></p>
                                    </div>
                                    <div v-if="expandedReport.notes">
                                        <h3 class="strong-text--text font-weight-semibold mb-1">Notes & Recommendations</h3>
                                        <p class="text--text" style="white-space: pre-line;" v-html="urlify(escapeHtmlText(expandedReport.notes))"></p>
                                    </div>
                                    <div>
                                        <v-btn v-if="expandedReport.recording_url" color="primary" small :href="expandedReport.recording_url" target="_system" class="me-2">
                                            <v-icon size="18" left class="me-1">mdi-file-video</v-icon>
                                            <div>Recording</div>
                                        </v-btn>
                                        <v-btn v-if="isTeacher" color="muted" outlined small @mousedown.stop @touchstart.stop @click.stop="openEditDialog(report)">
                                            <v-icon size="18" left class="me-1">mdi-pencil</v-icon>
                                            <div>Edit</div>
                                        </v-btn>
                                    </div>
                                    <div v-if="expandedReport.recordings && expandedReport.recordings.length" class="d-flex align-center flex-wrap mt-3">
                                        
                                        <v-btn v-for="(recording, i) in expandedReport.recordings" :key="recording.id" color="primary" style="text-transform: capitalize;" height="32" :href="recording.url" target="_system" class="me-2 mb-1">
                                            <v-icon size="20" left class="me-1">mdi-file-video</v-icon>
                                            <span>Recording {{ expandedReport.recordings.length > 1 ? ' #' + (i+1) : '' }}</span>
                                        </v-btn>
                                    </div>
                                </div>
                            </v-expand-transition>
                        </v-list-item-content>
                        <v-list-item-icon class=" pa-0 ms-2">
                            <v-btn icon>
                                <v-icon v-if="expandReport && expandedReport.id === report.id" color="primary" @click.prevent.stop="unexpand">mdi-chevron-up</v-icon>
                                <v-icon v-else color="primary">mdi-chevron-down</v-icon>
                            </v-btn>
                        </v-list-item-icon>
                    </v-list-item>

                    <v-divider v-if="i < reports.length-1" inset style="opacity: 0.6" :key="'divider-' + report.id"></v-divider>
                </template>

            </v-list>
            <div v-else-if="!loading">
                <v-alert type="info" color="muted" text>
                    <class class="medium-text">You don't have class reports yet</class>
                </v-alert>
            </div>


            <div v-if="reportsNext" class="mt-4" @click="loadData()">
                <v-btn block text outlined color="primary" class="grey lighten-3">Load More...</v-btn>
            </div>
        </v-container>

        <v-dialog transition="slide-y-transition" v-model="editDialog" max-width="550" :fullscreen="phoneOnly" :fluid="phoneOnly">
            <v-card :class="{'fill-height': phoneOnly}" :style="`${iosSafeArea ? 'padding-top: 45px!important; ' : ''}`">
                <v-card-title class="mb-1">Edit Class Report</v-card-title>
                <v-card-text>
                    <v-form ref="addReportForm">
                        <v-select v-model="editReportForm.evaluation" filled label="Evaluation" :items="['Excellent', 'Good', 'Needs improvement']" :disabled="editing" :menu-props="{offsetY: true}"></v-select>
                        <v-textarea v-model="editReportForm.lesson_summary" filled label="Lesson Summary" :disabled="editing" rows="3" auto-grow no-resize></v-textarea>
                        <v-textarea v-model="editReportForm.notes" filled label="Notes & Recommendations" :disabled="editing" rows="3" auto-grow no-resize></v-textarea>
                        <v-text-field v-if="appData.allow_manual_recording_url" v-model="editReportForm.recording_url" prepend-inner-icon="mdi-file-video" filled label="Recording URL" :disabled="savingClassReport"></v-text-field>

                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="editing" @click="updateClassReport = false">Cancel</v-btn>
                    <v-btn text color="primary" :disabled="editing" @click="updateClassReport">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import EnrollmentsSelect from '@/components/custom/enrollments-select'

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';


export default {
    name: "reports",
    components: {
        EnrollmentsSelect
    },
    data(){
        return {
            searchQuery: '',
            loading: false,

            enrollment_id: '',

            editDialog: false,
            editing: false,
            
            editReportForm: {
                id: null,
                evaluation: '',
                lesson_summary: '',
                notes: '',
                recording_url: '',
            },

            expandReport: false,
            expandedReport: null,
        }
    },
    computed: {
        reports(){
            return this.$store.state.classReportsModule.reports;
        },
        reportsNext(){
            return this.$store.state.classReportsModule.reportsNext;
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        enrollment_id(){
            this.loadData(true);
        }
    },
    methods: {
        unexpand(){
            this.expandReport = false;
            this.expandedReport = null;
        },
        expand(report){
            this.expandReport = true;
            this.expandedReport = report;
        },
        openEditDialog(report){
            Object.assign(this.editReportForm, {
                id: report.id,
                evaluation: report.evaluation,
                lesson_summary: report.lesson_summary,
                notes: report.notes,
                recording_url: report.recording_url,
            });
            this.editDialog = true;
        },
        updateClassReport(){
            if (!this.editing){
                this.editing = true;
                const data = this.editReportForm;
                this.$store.dispatch('updateClassReport', {id: this.editReportForm.id, data}).then(()=>{
                    this.editing = false;
                    this.editDialog = false;
                    this.showMsg('Changes saved successfully', 'success');
                    
                }).catch(()=>{
                    this.editing = false;
                    this.showMsg('Error occurred during preforming the action', 'error');
                })
            }
        },
        
        loadData(initialLoad=false){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('loadClassReports', {initialLoad, enrollment_id: this.enrollment_id}).then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        ...GlobalMethods
    },
    mounted(){
        /* if (!this.reports || this.reports.length === 0){
            this.loadData(true);
        } */
        this.loadData(true);
    }
};
</script>
